module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.eot?5739d02394088b39be41cbe628723cfa";